export const POSITION_CLASSES = {
  center: 'object-center',
  top: 'object-top',
  bottom: 'object-bottom',
  left: 'object-left',
  right: 'object-right',
  'top-left': 'object-top-left',
  'top-right': 'object-top-right',
  'bottom-left': 'object-bottom-left',
  'bottom-right': 'object-bottom-right'
};
